import { Component, ComponentInterface, h, Host } from "@stencil/core";

@Component({
    tag: "ux-error-control",
    styleUrl: "error-control.scss",
    shadow: true
})
export class ErrorControl implements ComponentInterface {
    render() {
        return (
            <Host>
                <slot />
            </Host>
        );
    }
}
